import { inject, provideAppInitializer } from '@angular/core';
import { ConfigService } from '@app/shared/config/config.service';
import { AppInsightsService, ConsoleLogService } from '@app/shared/logging/implementations';
import { I18nService } from '@app/shared/services/i18n.service';

async function initConfigAndLogging () {
	const config = inject(ConfigService);
	const consoleLog = inject(ConsoleLogService);
	const appInsights = inject(AppInsightsService);
	const i18n = inject(I18nService);

	try {
		await config.load();
		consoleLog.init();
		await appInsights.init(); 
		await i18n.setup();
	} catch (e) {
		console.error('Config/logging/i18n init failed', e);
	}
}

export const APP_INITIALIZERS = [
	provideAppInitializer(initConfigAndLogging)
];